// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const segmentedControlClasses = {
  group: "qui-segmented-control__root",
  item: "qui-segmented-control__item",
  itemHiddenInput: "qui-segmented-control__item-hidden-input",
  itemText: "qui-segmented-control__item-text",
} as const
